import { render } from "./OrderPaymentCard.vue?vue&type=template&id=508c1f2e"
import script from "./OrderPaymentCard.vue?vue&type=script&lang=js"
export * from "./OrderPaymentCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__